import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import ReminderSettings from '../../../../../UI/ReminderSettings'
import { TRoles } from '../../../../../shared/const'

import styles from '../style.module.scss'

/**
 * „Mein Profil" → Erinnerungen per E-Mail (seit 14.10.2026).
 *
 * Jede Verwaltungsrolle stellt hier ihre eigenen Erinnerungen ein. Für
 * Landesadmins ist das der einzige Weg — „Administration" steht nur
 * Bundesadmins offen, und der Server lässt Landesadmins ohnehin nur das
 * eigene Konto ändern. Dieselbe Komponente steht im Fenster eines Kontos unter
 * „Administration".
 */
function Reminders(props) {
	const { t } = useTranslation()

	if (!props.userId || ![TRoles.ADMIN, TRoles.FEDERAL_ADMIN].includes(props.role)) return null

	return (
		<div className={styles.root} id="erinnerungen">
			<div className={styles.section}>
				<h1 className={styles.sectionTitle}>{t('Email reminders')}</h1>
				<p className={styles.remindersNote}>{t('remindersOwnHint')}</p>
				<div className={styles.sectionContent}>
					<ReminderSettings userId={props.userId} role={props.role} />
				</div>
			</div>
		</div>
	)
}

Reminders.propTypes = {
	userId: PropTypes.number,
	role: PropTypes.string
}

const mapStateToProps = state => ({
	userId: state.user.profile?.id,
	role: state.user.role
})

export default connect(mapStateToProps)(Reminders)
